export const cStates = {
    ENABLED: 1,
    DISABLED: 2
}

